'use client';

import { useMemo } from 'react';

import { useMeQuery } from '@/entities/me/meQueries';
import { useSession } from '@/shared/hooks/use-session';
import { getStrapiMedia } from '@/shared/utils/utils';

/**
 * Единая картинка и имя для UI.
 * Сначала Strapi, иначе NextAuth.
 */
export const useDisplayProfile = () => {
  const { data: me, isPending: mePending } = useMeQuery();
  const { user: sessionUser, isPending: sessionPending, token } = useSession();

  return useMemo(() => {
    const hasStrapiProfile = Boolean(me?.id);
    const image =
      (hasStrapiProfile ? (me?.image ?? undefined) : undefined) ??
      (sessionUser?.image ? getStrapiMedia(sessionUser.image) : undefined);

    const displayName =
      (hasStrapiProfile ? me?.username : undefined) ??
      sessionUser?.name ??
      undefined;

    /** Таб «Профиль» в нижнем меню: аватар вместо иконки, если есть JWT */
    const showProfileTabAvatar = Boolean(token);

    return {
      image,
      displayName,
      isPending: mePending || sessionPending,
      /** Есть сессия Strapi / NextAuth с JWT */
      hasBackendSession: Boolean(token),
      showProfileTabAvatar,
    };
  }, [
    me?.id,
    me?.image,
    me?.username,
    sessionUser?.image,
    sessionUser?.name,
    mePending,
    sessionPending,
    token,
  ]);
};
